// removed by extract-text-webpack-plugin
module.exports = {"xl":"sizeL__xl___1BHeA breakPointL-marginRight-xl","l":"sizeL__l___1Dwnw breakPointL-marginRight-l","m":"sizeL__m___3T80R breakPointL-marginRight-m","s":"sizeL__s___lbmSZ breakPointL-marginRight-s","xs":"sizeL__xs___2STKp breakPointL-marginRight-xs","xxs":"sizeL__xxs___1TpZQ breakPointL-marginRight-xxs"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-grid/InlineGrid/style/sizeL.css
// module id = 16
// module chunks = 0 1 2 3 6